import React from 'react';
import { FaProjectDiagram , FaCloud, FaCode, FaSearch, FaMobile, FaServer } from 'react-icons/fa';

const Services = () => {
  const services = [
    {
      icon: <FaProjectDiagram  className="text-4xl text-netbernet-blue" />,
      title: "ERP Solutions",
      description: "Smart ERP systems that integrate and manage your business operations helping you work faster, smarter, and more efficiently."
    },
    {
      icon: <FaCloud className="text-4xl text-netbernet-blue" />,
      title: "Cloud Services",
      description: "Cloud migration, management, and optimization services to enhance your business scalability."
    },
    {
      icon: <FaCode className="text-4xl text-netbernet-blue" />,
      title: "Web Development",
      description: "Custom web applications using modern technologies like PHP, .NET, Java, and responsive frameworks."
    },
    {
      icon: <FaSearch className="text-4xl text-netbernet-blue" />,
      title: "SEO & Digital Marketing",
      description: "Comprehensive digital marketing strategies to increase your online visibility and drive growth."
    },
    {
      icon: <FaMobile className="text-4xl text-netbernet-blue" />,
      title: "Mobile Apps & Software",
      description: "Native and cross-platform mobile applications tailored to your specific business needs."
    },
    {
      icon: <FaServer className="text-4xl text-netbernet-blue" />,
      title: "Hosting & Domains",
      description: "Reliable domain registration, hosting services, and business email solutions."
    }
  ];

  return (
    <section id="services" className="py-16 px-6 bg-netbernet-white">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-netbernet-black mb-4">Our Services</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive IT solutions designed to empower your business and drive digital transformation.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100">
              <div className="mb-6">{service.icon}</div>
              <h3 className="text-xl font-semibold mb-4 text-netbernet-black">{service.title}</h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;